import { isHomeChatEnabled } from '@/config/featureFlags';
import { useAuth } from '@/hooks/useAuth';

/**
 * Home Chat gate (ANA-263).
 *
 * "Home Chat" is the conversational surface on the home page — the lobby
 * composer (text + voice) and the suggestion pills — plus the dedicated `/chat`
 * thread it opens into. It needs more work (LLM-driven navigation to the scoping
 * call isn't reliable yet; next-action pills still being verified), so for
 * non-admin users (e.g. a time-poor prospect CEO) we hide it: they land on a
 * clean home whose only action is "Start scoping call".
 *
 * The rule: admins always see Home Chat (so the team keeps dogfooding it in
 * prod); everyone else sees it only once the `FEATURE_HOME_CHAT` flag is on.
 * Flipping that env flag re-enables Home Chat for everyone with no code change.
 *
 * Pure so it can be unit-tested and reused outside React (e.g. the `/` page,
 * which already reads `useAuth`).
 */
export function isHomeChatVisible(role: string | null | undefined): boolean {
  return role === 'admin' || isHomeChatEnabled();
}

/** React hook form: reads the current user's role from `useAuth`. */
export function useShowHomeChat(): boolean {
  const { user } = useAuth();
  return isHomeChatVisible(user?.role);
}
